export default __webpack_public_path__ + "static/illustration-hero-middle-school-3d12cc15e3da32243ebe2242ec619e51.svg";